<template>
  <v-container class="custom-container">
    <v-row dense>
      <v-col cols="12">
        <v-card class="pa-5" elevation="0" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
          <v-row dense>
            <v-col cols="7" sm="9" md="10">
              <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search Here ..." single-line solo
                hide-details class="custom-v-input"></v-text-field>
            </v-col>
            <v-col cols="5" sm="3" md="2">
              <v-btn large tile block elevation="0" class="ma-0 text-capitalize btn-account" color="greenMain"
                height="48px" @click="openDialog('add')">
                Add New
              </v-btn>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="12">
              <v-card class="pa-3 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
                <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
                  <v-data-table :headers="headers" :items="payment_methods" :search="search" :items-per-page="7">
                    <template v-slot:item.sl="{ index }">
                      {{ index + 1 }}
                    </template>
                    <template v-slot:item.method_type="{ item }">
                      {{ getMethodTypeTitle(item.method_type) }}
                    </template>
                    <template v-slot:item.method_name="{ item }">
                      {{ item.method_name || "N/A" }}
                    </template>
                    <template v-slot:item.status="{ item }">
                      {{ item.status === 1 ? 'Active' : 'Inactive' }}
                    </template>
                    <template v-slot:item.details="{ item }">
                      <div class="d-flex align-center justify-center">
                        <div class="links text-decoration-none mr-3">
                          <v-icon color="#039de9" small @click="openDialog('edit', item)">
                            mdi-pencil-outline
                          </v-icon>
                        </div>
                        <v-dialog v-model="deletePayModal[item.id]" max-width="400" class="rounded-0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon color="#FF567F" small v-bind="attrs" v-on="on">
                              mdi-trash-can-outline
                            </v-icon>
                          </template>
                          <v-card rounded="0" width="400" class="auth-modal-card"
                            :color="$vuetify.theme.dark ? '#111A26' : '#ffffff'">
                            <v-card-title class="px-0 pt-0"> Delete? </v-card-title>
                            <v-card-text class="px-0">Do you want to delete?</v-card-text>
                            <v-card-actions class="px-0 pb-0">
                              <v-btn class="elevation-0" :color="$vuetify.theme.dark ? '#FF567F' : '#FF567F'"
                                @click="deleteItem(item)">
                                Delete
                              </v-btn>
                              <v-btn class="elevation-0" :color="$vuetify.theme.dark ? '#111A26' : '#ffffff'" outlined
                                @click="closePayModal(item)">
                                Cancel
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>

                      </div>
                    </template>
                  </v-data-table>
                </v-sheet>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog.show" max-width="461" content-class="deposit-withdraw-popup marketingPopup">
      <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
        <v-card-title class="pb-3 text-left justify-start pl-3">
          {{ dialog.title }}
        </v-card-title>
        <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
          {{ dialog.subtitle }}
        </v-card-subtitle>
        <v-card class="deposit-form px-3 py-4" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
          <v-row>
            <v-col cols="12">
              <fieldset>
                <legend>Payment Method*</legend>
                <v-text-field v-model="dialog.formData.method_name" label="Write Here" single-line solo hide-details
                  class="custom-select"></v-text-field>
              </fieldset>
            </v-col>
            <v-col cols="12">
              <fieldset>
                <legend>Method Type*</legend>
                <v-select v-model="dialog.formData.method_type" :items="methodTypeOptions" item-text="title"
                  item-value="id" label="Select Method Type" single-line solo hide-details
                  class="custom-select"></v-select>
              </fieldset>
            </v-col>
            <v-col cols="12">
              <fieldset>
                <legend>Status*</legend>
                <v-select v-model="dialog.formData.status" :items="statusOptions" item-text="text" item-value="value"
                  label="Select Status" single-line solo hide-details class="custom-select"></v-select>
              </fieldset>
            </v-col>
          </v-row>
        </v-card>
        <v-card-actions>
          <v-row dense>
            <v-col cols="12">
              <v-btn tile @click="submitForm" elevation="0" class="text-capitalize btn-account mr-3 px-sm-8"
                color="greenMain">Submit</v-btn>
              <v-btn tile color="#FF567F" @click="dialog.show = false" elevation="0"
                class="text-capitalize btn-account px-sm-8">Close</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { PARTNERPAYMENTMETHOD__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      search: "",
      deletePayModal: {},
      dialog: {
        show: false,
        title: "",
        subtitle: "",
        mode: "",
        formData: {
          method_name: "",
          method_type: "",
          status: 1
        }
      },
      headers: [
        { text: "Sl", value: "sl", align: "start" },
        { text: "Method Type", value: "method_type" },
        { text: "Payment Method", value: "method_name" },
        { text: "Status", value: "status" },
        { text: "Action", value: "details" },
      ],
      statusOptions: [
        { text: "Active", value: 1 },
        { text: "Inactive", value: 0 }
      ],
      methodTypeOptions: [
        { id: 0, title: "Bank" },
        { id: 1, title: "Debit/Credit Cards" },
        { id: 2, title: "E-Wallet" },
        { id: 3, title: "Crypto" },
        { id: 4, title: "Internal Transfer" }
      ]
    };
  },

  computed: {
    ...mapState("partnerpaymethods", ["payment_methods"]),
    ...mapState("admins", ["loggedAdmin"]),
  },

  methods: {
    ...mapActions("partnerpaymethods", [
      PARTNERPAYMENTMETHOD__ACTIONS.PARTNER_PAYMENT_METHODS,
      PARTNERPAYMENTMETHOD__ACTIONS.CREATE_PARTNER_PAYMENT_METHOD,
      PARTNERPAYMENTMETHOD__ACTIONS.EDIT_PARTNER_PAYMENT_METHOD,
      PARTNERPAYMENTMETHOD__ACTIONS.DELETE_PARTNER_PAYMENT_METHOD
    ]),

    openPayModal(item) {
      this.$set(this.deletePayModal, item.id, true);
    },

    closePayModal(item) {
      this.$set(this.deletePayModal, item.id, false)
    },


    openDialog(mode, item = null) {
      this.dialog.mode = mode;
      if (mode === 'add') {
        this.dialog.title = "Add New Payment Method";
        this.dialog.subtitle = "You Can Add New Payment Method For Your Partner";
        this.dialog.formData = { method_name: "", method_type: "", status: 1 };
      } else if (mode === 'edit') {
        this.dialog.title = "Edit Payment Method";
        this.dialog.subtitle = "You Can Edit This Payment Method";
        this.dialog.formData = { ...item };
      }
      this.dialog.show = true;
    },

    async submitForm() {
      try {
        if (this.dialog.mode === 'add') {
          const createdData = {
            method_name: this.dialog.formData.method_name,
            method_type: this.dialog.formData.method_type,
            status: this.dialog.formData.status
          }
          console.log(createdData)
          await this[PARTNERPAYMENTMETHOD__ACTIONS.CREATE_PARTNER_PAYMENT_METHOD](createdData);
        } else if (this.dialog.mode === 'edit') {
          const editedData = {
            id: this.dialog.formData.id,
            method_name: this.dialog.formData.method_name,
            method_type: this.dialog.formData.method_type,
            status: this.dialog.formData.status
          }
          await this[PARTNERPAYMENTMETHOD__ACTIONS.EDIT_PARTNER_PAYMENT_METHOD](editedData);
        }
        this.dialog.show = false;
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    },
    async deleteItem(item) {
      await this[PARTNERPAYMENTMETHOD__ACTIONS.DELETE_PARTNER_PAYMENT_METHOD](item.id);
      this.$set(this.deletePayModal, item?.id, false);
    },
    getMethodTypeTitle(id) {
      const method = this.methodTypeOptions.find(option => option.id === id);
      return method ? method.title : "N/A";
    }
  },

  async created() {
    await this[PARTNERPAYMENTMETHOD__ACTIONS.PARTNER_PAYMENT_METHODS]();
  },
};
</script>